<div class="relative w-full" [class]="dropdownExpanded() ? 'z-[11]' : 'z-[10]'">
  <div #dropdownTarget [class]="dropdownMenuClasses()" tabindex="-1" role="listbox">
    @if (dropdown?.isVisible()) {
      <div class="flex max-h-[476px] flex-col gap-3xs overflow-y-auto">
        @for (section of filteredOptions(); let sectionIndex = $index; track $index) {
          <div class="flex flex-col gap-3xs">
            @if (section.title) {
              <div class="px-xs pb-3xs pt-xs">
                <span
                  class="font-heading text-xs font-semibold uppercase leading-sm text-grey-100"
                  >{{ section.title }}</span
                >
              </div>
            }
            @for (option of section.options; track $index) {
              <app-dropdown-item
                [text]="option.label"
                [icon]="option?.icon ?? ''"
                [selected]="isOptionSelected(option)"
                (click)="onSelect(option)"
                [radioControlName]="controlName()"
                [radioValue]="option.type === 'radio' ? option.value : null"
                [showCheckbox]="option.type === 'checkbox'"
                [showRadioButton]="option.type === 'radio'"
              ></app-dropdown-item>
            }
            @if ($index < filteredOptions().length - 1) {
              <div class="my-3xs w-full border-t border-grey-50"></div>
            }
          </div>
        }
        @if (filteredOptions().length === 0) {
          <div class="px-3 py-2 text-sm font-medium text-grey-100">Δεν υπάρχουν αποτελέσματα</div>
        }
      </div>
    }
  </div>

  <div [class]="dropdownTriggerClasses()">
    <div
      #dropdownTrigger
      [ngClass]="{
        'cursor-not-allowed': isDisabled(),
        'cursor-pointer': !isDisabled() && type() === 'default',
      }"
    >
      @if (type() === 'search-bar') {
        <app-search-field
          [formGroup]="dropdownForm"
          [controlName]="'dropdownFormControl'"
          [placeholder]="placeholder()"
          [disabled]="isDisabled()"
          [size]="size()"
          [isDropdown]="true"
          [dropdownSelectedValue]="selected()?.label"
          [dropdownExpanded]="dropdownExpanded()"
          (onClickRightButton)="clearSelection()"
        ></app-search-field>
      }
      @if (type() === 'default') {
        <app-generic-input-field
          [formGroup]="dropdownForm"
          [controlName]="'dropdownFormControl'"
          [placeholder]="placeholder()"
          [disabled]="isDisabled()"
          [size]="size()"
          [isDropdown]="true"
          [dropdownExpanded]="dropdownExpanded()"
        ></app-generic-input-field>
      }
    </div>
  </div>
</div>
